import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { FormikTextArea } from 'src/components/shared/form/formik/FormikTextArea'
import { FormikTextField } from 'src/components/shared/form/formik/FormikTextField'
import type {
  InsuranceProductFormMode,
  InsuranceProductFormValues,
} from './InsuranceProductForm.interface'

const OPTIONAL_FIELDS_HINT =
  'Optional fields can be updated but not cleared — the admin API ignores empty values.'

interface Props {
  mode: InsuranceProductFormMode
}

const InsuranceProductFormContentComponent = ({ mode }: Props) => {
  return (
    <div css={tw`flex flex-col gap-4`}>
      <FormikTextField<InsuranceProductFormValues>
        name="name"
        label="Name"
        placeholder="e.g. General Liability"
      />
      {/* BasicTextArea does not set fullWidth the way BasicTextField does, so pass it here. */}
      <FormikTextArea<InsuranceProductFormValues>
        name="description"
        label="Description"
        placeholder="What this product covers"
        minRows={3}
        fullWidth
      />
      <FormikTextArea<InsuranceProductFormValues>
        name="explanation"
        label="Explanation"
        placeholder="Longer explanation shown alongside the product"
        minRows={3}
        fullWidth
      />
      {mode === 'edit' ? (
        <Typography variant="body2" css={tw`text-shades-500`}>
          {OPTIONAL_FIELDS_HINT}
        </Typography>
      ) : null}
    </div>
  )
}

export const InsuranceProductFormContent = memo(InsuranceProductFormContentComponent)
